import { Navigate } from 'react-router-dom'
import { useMe } from '@/hooks/useMe'
import { homeForUser } from '@/utils/home'
import { ResourceChooser } from '@/components/routing/ResourceChooser'

/**
 * `/` index page — pure role-based dispatcher.
 *
 * - sys_admin → /admin
 * - provider_admin → /provider/:provider_id
 * - clinic_admin (single clinic) → /clinic/:id
 * - clinic_admin (multiple) → ResourceChooser
 * - investor → /investor/clinics
 * - others / no scope → ResourceChooser or error
 */
export default function Dashboard() {
  const { user, isLoading } = useMe()

  if (isLoading) return null
  if (!user) return <Navigate to="/login" replace />

  const target = homeForUser(user)
  if (target !== '/') return <Navigate to={target} replace />

  // target === '/' — multi-scope user with no canonical home; show chooser.
  const s = user.scopes
  if (!s) {
    return <div className="p-8 text-red-600">帳號無任何 scope 權限</div>
  }
  if ((s.clinic_group_ids?.length ?? 0) > 1)
    return <ResourceChooser type="clinic_group" ids={s.clinic_group_ids} />
  if ((s.ad_supplier_group_ids?.length ?? 0) > 1)
    return <ResourceChooser type="ad_supplier_group" ids={s.ad_supplier_group_ids} />
  if ((s.clinic_ids?.length ?? 0) > 1)
    return <ResourceChooser type="clinic" ids={s.clinic_ids} />
  if ((s.supplier_ids?.length ?? 0) > 1)
    return <ResourceChooser type="ad_supplier" ids={s.supplier_ids} />

  return <div className="p-8 text-red-600">帳號資料異常：缺少有效 scope</div>
}
